<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card"> 

        
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <!-- <Button
            label="New Activity Type"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          /> -->
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="globalFilter"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
        
        <HistoryTable
          :data="customerHistory"
          :name="'Customer History'"
          :loading="loading"
          :globalFilter="globalFilter"
          :customer1="customer"
        />

      </div>
    </div>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import HistoryTable from '../../universalComponents/customer/customerHistoryTable'

export default {
  components: {
    HistoryTable
  },
  props: ["customer"],
  data: () => ({
    customerService: new CustomerService(),
    globalFilter: '',
    customerHistory: [],
    requesting: false
  }),
  computed: {
    loading() {
      if (this.customerHistory && this.customerHistory[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    },
  },
  created() {
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }

    this.setupComponent()
  },
  methods: {
    setupComponent() {
      
      if (this.$route.params.custid) {
        this.requesting = true
        this.customerService
          .getCustomerHistory(this.$route.params.custid)
          .then(data => {
            this.requesting = false
            this.customerHistory = data
          })
          .catch(err => {
            this.requesting = false
            
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
      }
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>